import { GameConstants } from "./GameConstants";
import { AudioManager } from "./AudioManager";
import { GameVars } from "./GameVars";
import { SplashState } from "./states/splash-state/SplashState";

export class GameManager {

    private static game: Phaser.Game;

    public static init(game: Phaser.Game): void {

        GameManager.game = game;

        GameVars.minesweeper = require("minesweeper");

        
        PokiSDK.init().then(
            () => {
                console.log("Poki SDK successfully initialized");
                // your code to continue to game
                GameManager.readGameData();
            }   
        ).catch(
            () => {
                console.log("Initialized, but the user likely has adblock");
                // your code to continue to game
                GameManager.readGameData();
            }   
        );
        PokiSDK.setDebug(false);
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {
                    GameVars.gameData = {
                        muted: false,
                        highscores: {
                            [GameConstants.DIFFICULTY_EASY]: { score: 10e5 },
                            [GameConstants.DIFFICULTY_MEDIUM]: { score: 10e5 },
                            [GameConstants.DIFFICULTY_HARD]: { score: 10e5 }
                        },
                        victories: {
                            easy: 0,
                            medium: 0,
                            hard:0
                        }
                    };
                }

                GameManager.writeGameData();
                GameManager.startGame();
            },
            function (error: Error): void {
                GameManager.log("error retriving saved game data.", error);
            }
        );
    }

    public static onGameAssetsLoaded(): void {
        PokiSDK.gameLoadingFinished();

        PokiSDK.gameplayStart();
        PokiSDK.gameplayStop();
        PokiSDK.commercialBreak().then(
            () => {
                console.log("Commercial break finished, proceeding to game");
                PokiSDK.gameplayStart();
                AudioManager.init(GameManager.game);

                GameManager.enterSplashState();
                // GameManager.enterBoardScene(GameConstants.DIFFICULTY_EASY);
            }
        );
    }

    public static enterSplashState(): void {

        if (GameManager.game) {
            GameManager.game.state.start("SplashState", true, false);
        }
    }

    public static enterBoardScene(difficulty: string): void {

        GameVars.difficulty = difficulty;

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {

            if (SplashState.currentInstance) {
                LaggedAPI.init("minesweppr_classic_gminins", "lagdevaF3001");
                GameManager.game.state.start("BoardState", true, false);
            } else {

                if (typeof prerollStart === "undefined") {
                    console.log("skip ad, prerollStart not found");
                    GameManager.game.state.start("BoardState", true, false);
                } else {
                    
                    LaggedAPI.APIAds.show("interstitial", "minesweeper-classic", "minesweeper-classic-game.png", function(response: any): void {
                    
                        if (response.success) {
                            console.log("ad done");
                            GameManager.game.state.start("BoardState", true, false);
                        } else {
                            console.log("ad error, continue");
                            GameManager.game.state.start("BoardState", true, false);
                        }
                    });
                }
            }

        } else {
            GameManager.game.state.start("BoardState", true, false);
        }
    }

    public static enterTutorialScene(): void {

        GameManager.game.state.start("TutorialState", true, false);
    }

    public static reset(): void {

        GameManager.enterBoardScene(GameVars.difficulty);
    }

    public static matchOver(): void {

        if (GameVars.gameData.highscores[GameVars.difficulty].score > GameVars.time) {
            GameVars.gameData.highscores[GameVars.difficulty].score = GameVars.time;
            
        }

        if (GameConstants.SPONSOR_LAGGED) {

            const api_awards = [];

            switch (GameVars.difficulty) {

                case GameConstants.DIFFICULTY_EASY:

                    GameVars.gameData.victories.easy ++;

                    if (GameVars.gameData.victories.easy === 5) {
                        api_awards.push("minesweepr_classicg_vaka001");
                    } else if (GameVars.gameData.victories.easy === 10) {
                        api_awards.push("minesweepr_classicg_vaka002");
                    } else if (GameVars.gameData.victories.easy === 15) {
                        api_awards.push("minesweepr_classicg_vaka003");
                    }

                    break;

                case GameConstants.DIFFICULTY_MEDIUM:

                    GameVars.gameData.victories.medium ++;

                    if (GameVars.gameData.victories.medium === 5) {
                        api_awards.push("minesweepr_classicg_vaka004");
                    } else if (GameVars.gameData.victories.medium === 10) {
                        api_awards.push("minesweepr_classicg_vaka004");
                    } else if (GameVars.gameData.victories.medium === 15) {
                        api_awards.push("minesweepr_classicg_vaka006");
                    }

                    break;

                case GameConstants.DIFFICULTY_HARD:

                    GameVars.gameData.victories.hard ++;

                    if (GameVars.gameData.victories.hard === 5) {
                        api_awards.push("minesweepr_classicg_vaka007");
                    } else if (GameVars.gameData.victories.hard === 10) {
                        api_awards.push("minesweepr_classicg_vaka008");
                    } else if (GameVars.gameData.victories.hard === 15) {
                        api_awards.push("minesweepr_classicg_vaka009");
                    }

                    break;

                default:
            }

            if (api_awards.length > 0) {

                LaggedAPI.Achievements.save(api_awards, function(response: any): void {
                    if (response.success) {
                        console.log("achievement saved");
                    } else {
                        console.log(response.errormsg);
                    }
                });
            }
            
            console.log(GameVars.gameData.victories);
        }

        GameManager.writeGameData();
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            },
            function (error: Error): void {
                GameManager.log("error saving game data", error);
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    private static startGame(): void {

        GameManager.game.state.start("PreLoader", true, false);
    }

    private static getGameStorageData(key: string, successCb: Function, failureCb: Function): void {

        try {
            const gameDataStr = localStorage.getItem(key);
            successCb(gameDataStr);
        } catch {
            successCb(null);
        }
    }

    private static setGameStorageData(key: string, value: any, successCb: Function, failureCb: Function): void {

        try {
            localStorage.setItem(key, JSON.stringify(value));
            successCb();
        } catch {
         //   console.log("local storage not supported");
        }
    }
}
